import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import { voltStatus, type VoltStatusMap, type VoltTone } from "./voltStatus";

const badgeVariant = {
  success: "success",
  warning: "warning",
  info: "info",
  destructive: "destructive-soft",
  neutral: "secondary",
} as const;

// The dot carries the Volt brand colour, the word carries the meaning.
const dotClass: Record<VoltTone, string> = {
  success: "bg-chart-2",
  warning: "bg-warning",
  destructive: "bg-chart-5",
  info: "bg-chart-4",
  neutral: "bg-muted-foreground",
};

export const VoltStatusBadge = ({
  status,
  map,
  className,
}: {
  status: string | null | undefined;
  map: VoltStatusMap;
  className?: string;
}) => {
  const { tone, label } = voltStatus(map, status);
  return (
    <Badge variant={badgeVariant[tone]} data-tone={tone} className={className}>
      <span aria-hidden className={cn("size-2 rounded-full", dotClass[tone])} />
      {label}
    </Badge>
  );
};
